import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { RelationBySubject } from '../../models';


export interface IRelationService {

	artistToCompanyRelations(artistId: string, group: boolean): Promise<RelationBySubject[]>;
	artistToProRelations(artistId: string, group: boolean): Promise<RelationBySubject[]>;

	proToCompanyRelations(proId: string, group: boolean): Promise<RelationBySubject[]>;
	proToArtistRelations(proId: string, group: boolean): Promise<RelationBySubject[]>;

	companyToProRelations(companyId: string, group: boolean): Promise<RelationBySubject[]>;
	companyToArtistRelations(companyId: string, group: boolean): Promise<RelationBySubject[]>;

}

@injectable()
export class RelationService implements IRelationService {

	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) { }


	public proToCompanyRelations(proId: string, group: boolean): Promise<RelationBySubject[]> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/relations/companies?group=${group}`;
		return this.httpClient.get<RelationBySubject[]>(url);
	}

	public proToArtistRelations(proId: string, group: boolean): Promise<RelationBySubject[]> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/relations/artists?group=${group}`;
		return this.httpClient.get<RelationBySubject[]>(url);
	}

	public companyToArtistRelations(companyId: string, group: boolean): Promise<RelationBySubject[]> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/relations/artists?group=${group}`;
		return this.httpClient.get<RelationBySubject[]>(url);
	}

	public companyToProRelations(companyId: string, group: boolean): Promise<RelationBySubject[]> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/relations/pros?group=${group}`;
		return this.httpClient.get<RelationBySubject[]>(url);
	}

	public artistToProRelations(artistId: string, group: boolean): Promise<RelationBySubject[]> {
		const url = `${this.settings.baseUrl}${this.settings.artistBaseUrl}/${artistId}/relations/pros?group=${group}`;
		return this.httpClient.get<RelationBySubject[]>(url);
	}

	public artistToCompanyRelations(artistId: string, group: boolean): Promise<RelationBySubject[]> {
		const url = `${this.settings.baseUrl}${this.settings.artistBaseUrl}/${artistId}/relations/companies?group=${group}`;
		return this.httpClient.get<RelationBySubject[]>(url);
	}
}
